import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Form',
    entityNamePlural: 'Forms',
    entityNameModule: 'offer',
    filters: { active: true },
  }), [])
}
